// extracted by mini-css-extract-plugin
export default {"clickable-card":"clickable-card_clickable-card__KrrrJ","clickable-card__chevron":"clickable-card_clickable-card__chevron__okDwH"};